import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import styled from 'styled-components';

export const AddInputButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 5px;

  .MuiBox-root {
    flex: 1;
  }
`;

export const RichTextLabel = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.4375em;
  letter-spacing: 0.00938em;
`;

export const RichTextContainer = styled.div`
  position: relative;

  .plain-text-placeholder {
    color: #999;
    overflow: hidden;
    position: absolute;
    text-overflow: ellipsis;
    top: calc(16.5px + 3px);
    left: 14px;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-size: 1rem;
    line-height: 1.4375em;
    letter-spacing: 0.00938em;
    user-select: none;
    display: inline-block;
    pointer-events: none;
  }
`;

export const CustomContentEditable = styled(ContentEditable)`
  border: 1px solid rgba(0, 0, 0, 0.23);
  height: 200px;
  padding: 16.5px 14px;
  border-radius: 4px;
`;
